export const httpStatus = {
  notFound: 404,
  internalServerError: 500,
  customError: 527,
};
